import { Component, Input, OnInit } from "@angular/core";

import { ProductDownloadsBaseComponent } from "@mypxplat/xplat/features";
import { UserService } from "@mypxplat/xplat/core";

@Component({
  selector: "myp-product-downloads",
  templateUrl: "product-downloads.component.html",
})
export class ProductDownloadsComponent extends ProductDownloadsBaseComponent implements OnInit {
  @Input() downloads: any;
  @Input() downloadSections: any;
  @Input() details: any;
  @Input() rawProduct: any;
  @Input() dealer: boolean = false;
  public displayedDownloadSection: any;

  constructor(userService: UserService) {
    super(userService);
  }

  ngOnInit() {
    this.displayDownloadSection(this.downloadSections[0]);
  }

  displayDownloadSection(section?, stringId?) {
    if (this.downloadSections.length) {
      if (section) {
        this.downloadSections.forEach((item) => (item.displayed = false));
        section.displayed = true;
        this.displayedDownloadSection = section;
      } else if (stringId) {
        const section = this.downloadSections.find((item) => item.value === stringId);
        if (section) {
          this.downloadSections.forEach((item) => (item.displayed = false));
          section.displayed = true;
          this.displayedDownloadSection = section;
        }
      }
    }
  }
}
